export const CommonTerritoryCrumbs = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Sistema',
    path: '/sistema',
  },
  {
    name: 'Territorio',
    path: '/sistema/geografiche/estero/territorio',
  },
];
